// Common
import actionTypes from './actionTypes'
import actions from './actions'
import constants from './constants'
import reducer from './reducer'
import saga from './saga'

// Components
import dashboard from './components/dashboard'

export default {
  actionTypes,
  actions,
  constants,
  reducer,
  saga,
  components: {
    dashboard
  }
}
